import { skipToken } from "@reduxjs/toolkit/query";
import { api } from "../state/api";
import { useTypedSelector } from "../state/store";
import { brandedPlanName } from "./planName";

export function useFormatPlanName() {
  const { appSlug, orgSlug } = useTypedSelector((state) => state.local);
  const { data: apps } = api.useGetAppsQuery(orgSlug ?? skipToken);
  const appUuid = apps?.data.find((app) => app.slug === appSlug)?.uuid;
  const { data: configuration } = api.useGetConfigurationQuery(
    appUuid ?? skipToken,
  );

  return (planName: string) =>
    configuration ? brandedPlanName(configuration, planName) : planName;
}
